module.exports = __webpack_public_path__ + "static/media/Web_Backing.13241937.png";